
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Bar,

  mixins: [reactiveProp],

  props: {
    chartData: {
      type: Object,
      default: (): Record<string, unknown> => ({}),
    },
    options: {
      type: Object,
      default: (): Record<string, unknown> => ({}),
    },
  },

  mounted(): void {
    this.renderChart(this.chartData, this.options);
  },
};
